export default "./dist/stdassets/cursors/digitizeCircle.cur";